import { render, staticRenderFns } from "./ResourcePermissionRowComponent.vue?vue&type=template&id=2be99662&scoped=true&"
import script from "./ResourcePermissionRowComponent.vue?vue&type=script&lang=ts&"
export * from "./ResourcePermissionRowComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ResourcePermissionRowComponent.vue?vue&type=style&index=0&id=2be99662&scoped=true&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2be99662",
  null
  
)

export default component.exports